import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import {
  generar_ficha_evoluciones_paciente,
  load_patient_evolution_list,
  load_patient_fichas_list,
} from "../../actions/clinic_content";
import EvolutionModal from "./EvolutionModal";
import FichaModal from "./FichaModal";

const initialSelectedFicha = {
  id: null,
  evo_list_name: "",
  evolutions_count: 0,
};

const initialEvoData = (patientId, fichaId = null) => ({
  evo_code: "",
  clinic_patient: patientId,
  evolution_list: fichaId,
  evo_date: "",
  evo_detail: "",
});

const EvolutionList = ({ patientId = null }) => {
  const [urls, setUrls] = useState({
    previous: null,
    next: null,
  });

  const [evoModalShow, setEvoModalShow] = useState(false);
  const [fichaModalShow, setFichaModalShow] = useState(false);

  const [evoList, setEvoList] = useState([]);
  const [selectedEvoData, setSelectedEvoData] = useState(
    initialEvoData(patientId),
  );

  const [fichasOptions, setFichasOptions] = useState([]);
  const [selectedFicha, setSelectedFicha] = useState(initialSelectedFicha);

  const handleSetUrl = (urlText, type) => {
    try {
      const url = new URL(urlText);
      const endpoint = url.pathname + url.search;
      setUrls((prev) => ({
        ...prev,
        [type]: `${process.env.REACT_APP_API_URL}${endpoint}`,
      }));
    } catch {
      setUrls((prev) => ({
        ...prev,
        [type]: null,
      }));
    }
  };

  const fetchEvoList = async () => {
    const data = await load_patient_evolution_list(patientId, selectedFicha.id);
    if (data) {
      setEvoList(data.results);
      handleSetUrl(data.next, "next");
      handleSetUrl(data.previous, "previous");
    }
  };

  const handlePageChange = async (pageUrl) => {
    if (!pageUrl) return;
    const data = await load_patient_evolution_list(null, null, pageUrl);
    if (data) {
      setEvoList([...data.results]);
      handleSetUrl(data.next, "next");
      handleSetUrl(data.previous, "previous");
    }
  };

  const fetchOptions = async () => {
    const fichas = await load_patient_fichas_list(patientId);
    if (fichas) {
      setFichasOptions(fichas);
      const selFicha = fichas.find((ficha) => ficha.id === selectedFicha.id);
      setSelectedFicha(selFicha || initialSelectedFicha);
    }
  };

  const handleFichaChange = (e) => {
    const value = e.target.value;
    if (value === "null") {
      setSelectedFicha(initialSelectedFicha);
      setSelectedEvoData((prev) => ({ ...prev, evolution_list: null }));
      return;
    }
    const ficha = fichasOptions.find((f) => f.id == value);
    if (ficha) {
      setSelectedFicha(ficha);
      setSelectedEvoData((prev) => ({ ...prev, evolution_list: ficha.id }));
    }
  };

  const handleAddEvolution = () => {
    setSelectedEvoData(initialEvoData(patientId, selectedFicha.id));
    setEvoModalShow(true);
  };

  const handleEditEvolution = (evo) => {
    setSelectedEvoData(evo);
    setEvoModalShow(true);
  };

  const handleGenerarFicha = async () => {
    // dispatch(checkAuthenticated());
    const data = await generar_ficha_evoluciones_paciente(
      patientId,
      selectedFicha.id,
    );
    if (data) {
      console.log(data);
      const url = `${process.env.REACT_APP_API_URL}${data.file}`;
      const link = document.createElement("a");
      link.href = url;
      const filename = url.substring(url.lastIndexOf("/") + 1);

      link.download = filename;
      link.target = "_blank";
      console.log(link);
      link.click();
    }
  };

  useEffect(() => {
    fetchOptions();
  }, []);

  useEffect(() => {
    fetchEvoList();
  }, [selectedFicha]);

  return (
    <div className="evolution-list-section">
      <div className="list-header d-flex justify-content-between">
        <h4 className="mb-0">Evoluciones</h4>

        <div className="d-flex gap-2 justify-content-end">
          <select
            className="w-fit"
            aria-label="Seleccionar ficha"
            value={selectedFicha.id == null ? "null" : selectedFicha.id}
            onChange={handleFichaChange}
          >
            <option value="null">General</option>
            {fichasOptions?.map((ficha) => (
              <option key={ficha.id} value={ficha.id}>
                {`${ficha.evo_list_name} - (${ficha.evolutions_count})`}
              </option>
            ))}
          </select>
          <Button
            variant="outline-primary d-flex align-items-center gap-2 text-nowrap"
            onClick={() => setFichaModalShow(true)}
          >
            {selectedFicha.id ? "Editar" : "Crear"} Ficha
          </Button>

          {selectedFicha.id && (
            <Button
              variant="outline-primary d-flex align-items-center gap-2 text-nowrap"
              onClick={handleGenerarFicha}
            >
              Generar Ficha
            </Button>
          )}
        </div>
      </div>

      <div className="evolution-list">
        <div className="d-flex justify-content-between">
          <div>
            <h5 className="mb-0">
              Ficha seleccionada:{" "}
              {selectedFicha.id
                ? `${selectedFicha.id} - ${selectedFicha.evo_list_name}`
                : "Ninguna"}
            </h5>
            {selectedFicha.id && (
              <h6>Nº de Evoluciones: {selectedFicha.evolutions_count}</h6>
            )}
          </div>
          <div className="d-flex gap-2 h-100">
            <Button
              variant="outline-primary d-flex align-items-center gap-2 text-nowrap"
              onClick={handleAddEvolution}
            >
              Agregar Evolución
            </Button>
          </div>
        </div>

        {evoList.length === 0 ? (
          <div className="text-center py-4 opacity-50">
            <i className="bi bi-journal-text fs-1 d-block mb-2" />
            <p className="mb-0">No hay evoluciones registradas.</p>
          </div>
        ) : (
          evoList.map((evo) => (
            <div className="evolution-item" key={evo.id}>
              <div className="evolution-item-header">
                <div className="evo-info">
                  <span>Fecha: {evo.evo_date}</span>
                  <span>Código: {evo.evo_code}</span>
                </div>
                <div className="evo-item-actions">
                  <Button
                    variant="outline-primary d-flex align-items-center gap-2"
                    onClick={() => handleEditEvolution(evo)}
                  >
                    <i className="bi bi-pencil-square" />
                  </Button>
                </div>
              </div>
              <div className="evolution-item-body">
                <p>{evo.evo_detail}</p>
              </div>
            </div>
          ))
        )}

        {/* Pagination */}
        {(urls.previous || urls.next) && (
          <div className="d-flex justify-content-between">
            <Button
              disabled={!urls.previous}
              onClick={() => handlePageChange(urls.previous)}
              variant="outline-primary d-flex align-items-center gap-2"
            >
              <i className="bi bi-arrow-left" />
            </Button>
            <Button
              disabled={!urls.next}
              onClick={() => handlePageChange(urls.next)}
              variant="outline-primary d-flex align-items-center gap-2"
            >
              <i className="bi bi-arrow-right" />
            </Button>
          </div>
        )}
      </div>

      <EvolutionModal
        show={evoModalShow}
        onHide={() => setEvoModalShow(false)}
        patientId={patientId}
        loadedEvoData={selectedEvoData}
        loadedFichaList={fichasOptions}
        onSuccess={() => {
          fetchOptions();
          setSelectedEvoData(initialEvoData(patientId, selectedFicha.id));
          fetchEvoList();
        }}
      />
      <FichaModal
        show={fichaModalShow}
        onHide={() => setFichaModalShow(false)}
        patientId={patientId}
        loadedFichaData={selectedFicha}
        onSuccess={() => fetchOptions()}
      />
    </div>
  );
};

export default EvolutionList;
